import { useQuery } from "@tanstack/react-query";

import { QueryKeys } from "@/api/core";
import { useApi } from "@/hooks";
import { gemProfileSchema } from "@/schemas";

function useGemProfile() {
  const api = useApi();

  const queryInfo = useQuery({
    queryKey: QueryKeys.gems.profile(),
    queryFn: async () => {
      const { data } = await api.get("/api/v1/gems_profile");

      return gemProfileSchema.parse(data);
    },
  });

  return queryInfo;
}

export { useGemProfile };
